>
<template>
  <section class="mb-5">
    <div class="section-title">
      <h5>CUSTOMER INFO</h5>
    </div>

    <template v-if="!isDetail">
      <b-row class="mb-3">
        <b-col md="6">
          <label class="font-weight-600 d-block mb-2">Customer Type</label>
          <div class="d-flex align-items-center">
            <b-form-radio
              v-model="localState.customerType"
              name="customer-type"
              value="active"
              :disabled="isDetail"
              class="mr-3"
            >
              Customer Active
            </b-form-radio>
            <b-form-radio
              v-model="localState.customerType"
              name="customer-type"
              value="prospect"
              :disabled="isDetail"
            >
              Customer Prospect
            </b-form-radio>
          </div>
        </b-col>
        <b-col md="6" class="d-flex align-items-end">
          <b-form-group
            label="Customer Active Name"
            label-for="customer-active"
            label-class="font-weight-600"
            class="w-100"
          >
            <template #label>
              <div>
                Customer Active Name
                <span class="text-red">*</span>
              </div>
            </template>
            <template v-if="!isDetail">
              <v-select
                id="customer-active"
                :options="customerOptions"
                v-model="localState.customerActive"
                :disabled="localState.createNewCustomerProspect"
                placeholder="Select Customer"
                track-by="id"
                label="account_name"
                required
              />
              <!-- <div v-if="localState.customerType === 'prospect'" class="d-flex align-items-center mt-2">
                <b-form-checkbox v-model="localState.createNewCustomerProspect" :disabled="isDetail">
                  Create New Customer Prospect
                </b-form-checkbox>
              </div> -->
            </template>
            <template v-else>
              <p class="form-control-plaintext">
                {{
                  customerOptions.find(
                    (el) => el.value === localState.customerActive
                  )?.text || '-'
                }}
              </p>
            </template>
          </b-form-group>
          <b-button
            v-if="!isDetail && localState.customerType != 'active'"
            variant="primary"
            class="ml-2 mb-3"
            :disabled="isDetail"
            style="height: 36px"
            @click="showSidebar = true"
          >
            <i class="fa fa-plus"></i>
          </b-button>
        </b-col>
      </b-row>
    </template>

    <div
      v-if="!localState.createNewCustomerProspect && localState?.customerActive"
    >
      <b-row v-for="(row, idx) in infoRows" :key="idx" class="mb-3">
        <b-col cols="5" md="4" class="d-flex justify-content-between">
          <span>{{ row.label }}</span>
          <span>:</span>
        </b-col>
        <b-col cols="7" md="8">
          <span>{{ row.value || '-' }}</span>
        </b-col>
      </b-row>
    </div>
    <!-- Custom Sidebar -->
    <custom-sidebar
      v-model="showSidebar"
      size="80%"
      :title="`New Customer Prospect`"
    >
      <template v-if="showSidebar">
        <FormCustomerNew
          @close="showSidebar = false"
          @submitted="
            (val) => {
              $emit('refecthCustomerList', val)
              localState.customerActive = val.id
            }
          "
        />
      </template>
    </custom-sidebar>
  </section>
</template>

<script>
import CustomSidebar from '@/src/components/global/CustomSidebar.vue'
import FormCustomerNew from '../../components/FormCustomerNew.vue'
export default {
  name: 'CustomerInfoSection',
  components: {
    FormCustomerNew,
    CustomSidebar,
  },
  props: {
    isDetail: { type: Boolean, default: false },
    customerOptions: { type: Array, default: () => [] },
    value: {
      type: Object,
      default: () => ({
        customerType: 'active',
        customerActive: null,
        createNewCustomerProspect: false,
        companyName: '',
        website: '',
        email: '',
        country: '',
        province: '',
        city: '',
        address: '',
        npwp: '',
        nib: '',
        picName: '',
        picPhone: '',
        picEmail: '',
      }),
    },
  },
  data() {
    return {
      showSidebar: false,
      localState: { ...this.value },
    }
  },
  computed: {
    infoRows() {
      const selected = this.customerOptions.find(
        (el) =>
          (el.value ?? el.id) === this.localState.customerActive?.id ||
          el.id === this.localState.customerActive?.id ||
          el.value === this.localState.customerActive?.id
      )
      if (!selected) return []
      console.log(selected, 'SELECTED')
      const map = {
        companyName:
          selected.account_name || selected.company_name || selected.text || '',
        website: selected.web || '',
        email: selected.email || selected.account_email || '',
        country: selected.country_id || selected.country,
        province: selected.province || selected.state || '',
        city: selected.city || '',
        address: selected.address || selected.account_address || '',
        npwp: selected.npwp || selected.tax_number || '',
        nib: selected.nib || '',
        picName: selected.pic_name || selected.primary_name || '',
        picPhone: selected.pic_phone || selected.primary_phone || '',
        picEmail: selected.pic_email || selected.primary_email,
      }
      return [
        { label: 'Company Name', value: map.companyName },
        { label: 'Website', value: map.website },
        { label: 'Email', value: map.email },
        { label: 'Country', value: map.country },
        { label: 'Provience', value: map.province },
        { label: 'City', value: map.city },
        { label: 'Address', value: map.address },
        // { label: 'Nomor Pokok Wajib Pajak (NPWP)', value: map.npwp },
        // { label: 'NIB Number', value: map.nib },
        { label: 'PIC Name', value: map.picName },
        { label: 'PIC Mobile Phone', value: map.picPhone },
        { label: 'PIC Email', value: map.picEmail },
      ]
    },
  },
  watch: {
    localState: {
      deep: true,
      handler(val) {
        // Only emit when value actually changes compared to current prop
        const stringify = (o) => {
          try {
            return JSON.stringify(o)
          } catch (e) {
            return ''
          }
        }
        if (stringify(val) !== stringify(this.value)) {
          this.$emit('input', val)
          this.$emit('change', val)
        }
      },
    },
    value: {
      deep: true,
      handler(v) {
        // Only sync localState when incoming value differs to avoid loops
        const stringify = (o) => {
          try {
            return JSON.stringify(o)
          } catch (e) {
            return ''
          }
        }
        if (stringify(this.localState) !== stringify(v)) {
          this.localState = { ...v }
        }
      },
    },
  },
}
</script>
